import styled from 'styled-components';

export const IconInSelect = styled.svg`
	width: 34px;
	height: 34px;
	cursor: pointer;
	fill: ${({ theme }) => theme.lightGrayColor};

	&:hover {
		fill: ${({ theme }) => theme.secondaryColor};
	}
`;

export const SimilarBtnsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 256px;
	border-radius: 4px;
	box-shadow: 0px 3px 6px 0px rgba(50, 50, 50, 0.2);
	color: ${({ theme }) => theme.primaryBlackColor};
	${({ theme }) => theme.typography.textM};
`;

export const SortBtnItem = styled.button`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0;
	background-color: transparent;
	border: none;
	color: ${({ theme, isActive }) => (isActive ? theme.primaryColor : theme.primaryBlackColor)};
	text-decoration: underline;
	cursor: pointer;
	padding: 11px 16px;
	text-decoration: none;

	&:not(:last-child) {
		border-bottom: 2px solid ${({ theme }) => theme.lightBlueLabelColor};
	}
	&:hover {
		background-color: ${({ theme }) => theme.backgroundGrayColor};
	}
`;

export const CheckIcon = styled.svg`
	width: 16px;
	height: 16px;
	fill: ${({ theme }) => theme.lightGrayColor};
`;
